//HABILITAR PROXY INVERSO PARA CORS INTERCEPTOR
//const cors_anywhere = "https://cors-anywhere.herokuapp.com/";
const base_url = "https://api.themoviedb.org/3/";
const now_playing_get = "movie/now_playing?";
const ontheair_series_get = "tv/on_the_air?";
const popular_movies_get = "movie/popular?";
const upcoming_movies_get = "movie/upcoming?";
const top_rated_get = "movie/top_rated?";
const top_rated_series_get = "tv/top_rated?";
const popular_series_get = "tv/popular?";
const series_get = "tv/"
const movies_get = "movie/";
const api_key = "api_key=2c4e30626dc1fcee2a373a9a71cf70f1";


export const nowPlaying = () => `${base_url}${now_playing_get}${api_key}`;
export const onTheAirSeries = () => `${base_url}${ontheair_series_get}${api_key}`;
export const popular = () => `${base_url}${popular_movies_get}${api_key}`;
export const upcoming = () => `${base_url}${upcoming_movies_get}${api_key}`;
export const popularSeries = () => `${base_url}${popular_series_get}${api_key}`;
export const topRated = () => `${base_url}${top_rated_get}${api_key}`;
export const topRatedSeries = () => `${base_url}${top_rated_series_get}${api_key}`;
export const moviesGet = movie_id => `${base_url}${movies_get}${movie_id}?${api_key}`;
export const videosGet = movie_id => `${base_url}${movies_get}${movie_id}/videos?${api_key}`;
export const videosGetSeries = movie_id => `${base_url}${series_get}${movie_id}/videos?${api_key}`;
export const castGet = movie_id => `${base_url}${movies_get}${movie_id}/credits?${api_key}`;
export const castGetSeries = movie_id => `${base_url}${series_get}${movie_id}/credits?${api_key}`;
export const popularSeriesGet = () => `${base_url}${popular_series_get}${api_key}`;
export const seriesGet = serie_id => `${base_url}${series_get}${serie_id}?${api_key}`;


